<template>
    <!-- ========================== -->
    <!-- HOME - AREAS OF EXPERTISE-->
    <!-- ========================== -->
    <section class="areas-section with-icon with-top-effect">
        <div class="container">
            <div class="row">
                <div class="col-md-5 col-sm-5 text-center">
                    <img :src="imageUrl" class="img-responsive" />
                </div>
                <div class="col-md-7 col-sm-7 text-left">
                    <div class="clearfix " style="padding-right: 3px;">
                        <div class="above-title">{{ aboveTitle }}</div>
                        <h4>{{ title }}</h4>
                    </div>
                    <div>
                        <em>{{ belowTitle }}</em>
                    </div>
                    <div v-html="content"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BasicArticle',
    props: {
            "image": String,
            "aboveTitle": String,
            "title": String,
            "belowTitle": String,
            "content": String,
    },
    computed:{
        imageUrl() {  
            return process.env.VUE_APP_API_BASE_URL + this.image;  
        }  
    }
}
</script>


// WEBPACK FOOTER //
// src/components/BasicArticle.vue